import { Pipe, PipeTransform } from '@angular/core';
import { SecurityEditManageProfileComponent } from 'src/app/security/security-edit/security-edit-manage-profile/security-edit-manage-profile.component';

@Pipe({
	name: 'filterUserNotifications',
	standalone: false,
})
export class FilterUserNotificationsPipe implements PipeTransform {
	transform(
		userNotificationControls: SecurityEditManageProfileComponent['form']['userNotifications'][0][],
		filter: { userNotificationCategoryTypeId: number; rfqSessionNudgeSettingChannelTypeId: number },
	): SecurityEditManageProfileComponent['form']['userNotifications'][] {
		const result = [];
		for (const userNotification of userNotificationControls) {
			if (
				userNotification.userNotificationCategoryTypeId.value === filter.userNotificationCategoryTypeId &&
				(!filter.rfqSessionNudgeSettingChannelTypeId ||
					userNotification.rfqSessionNudgeSetting.value?.rfqSessionNudgeSettingChannelTypes.some(
						c => c.id === filter.rfqSessionNudgeSettingChannelTypeId,
					))
			) {
				result.push(userNotification);
			}
		}
		return result;
	}
}
